import React, { useState } from 'react';
import { Mail, Phone, MapPin } from 'lucide-react';
export function ContactSection() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const {
      name,
      value
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Here you would typically handle form submission, like sending to an API
    alert('Gracias por tu mensaje. Nos pondremos en contacto contigo pronto.');
    setFormData({
      name: '',
      email: '',
      message: ''
    });
  };
  return <section id="contact" className="py-16 md:py-24 bg-gray-50" data-id="element-27">
      <div className="container mx-auto px-4" data-id="element-28">
        <div className="text-center mb-16" data-id="element-29">
          <h2 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900" data-id="element-30">
            Contáctanos
          </h2>
          <p className="text-lg text-gray-700 max-w-2xl mx-auto" data-id="element-31">
            Estamos listos para impulsar tu presencia digital. ¡Conversemos
            sobre tu proyecto!
          </p>
        </div>
        <div className="flex flex-col md:flex-row gap-12" data-id="element-32">
          <div className="md:w-1/2" data-id="element-33">
            <form onSubmit={handleSubmit} className="bg-white p-8 rounded-lg shadow-sm" data-id="element-34">
              <div className="mb-6" data-id="element-35">
                <label htmlFor="name" className="block text-gray-700 mb-2 font-medium" data-id="element-36">
                  Nombre
                </label>
                <input type="text" id="name" name="name" value={formData.name} onChange={handleChange} className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" required data-id="element-37" />
              </div>
              <div className="mb-6" data-id="element-38">
                <label htmlFor="email" className="block text-gray-700 mb-2 font-medium" data-id="element-39">
                  Email
                </label>
                <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" required data-id="element-40" />
              </div>
              <div className="mb-6" data-id="element-41">
                <label htmlFor="message" className="block text-gray-700 mb-2 font-medium" data-id="element-42">
                  Mensaje
                </label>
                <textarea id="message" name="message" value={formData.message} onChange={handleChange} rows={5} className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" required data-id="element-43"></textarea>
              </div>
              <button type="submit" className="bg-blue-600 text-white px-6 py-3 rounded-md font-medium hover:bg-blue-700 transition-colors w-full" data-id="element-44">
                Enviar mensaje
              </button>
            </form>
          </div>
          <div className="md:w-1/2" data-id="element-45">
            <div className="bg-white p-8 rounded-lg shadow-sm h-full" data-id="element-46">
              <h3 className="text-2xl font-bold mb-6 text-gray-900" data-id="element-47">
                Información de contacto
              </h3>
              <div className="space-y-6" data-id="element-48">
                <div className="flex items-start" data-id="element-49">
                  <Mail className="w-6 h-6 text-blue-600 mr-4 mt-1" data-id="element-50" />
                  <div data-id="element-51">
                    <p className="font-medium text-gray-900" data-id="element-52">Email</p>
                    <a href="mailto:vaxtechgroup@use.startmail.com" className="text-blue-600 hover:underline" data-id="element-53">
                      vaxtechgroup@use.startmail.com
                    </a>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-54">
                  <Phone className="w-6 h-6 text-blue-600 mr-4 mt-1" data-id="element-55" />
                  <div data-id="element-56">
                    <p className="font-medium text-gray-900" data-id="element-57">Teléfono</p>
                    <a href="tel:+5491176275731" className="text-blue-600 hover:underline" data-id="element-58">
                      +54 9 11 76275731
                    </a>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-59">
                  <MapPin className="w-6 h-6 text-blue-600 mr-4 mt-1" data-id="element-60" />
                  <div data-id="element-61">
                    <p className="font-medium text-gray-900" data-id="element-62">Ubicación</p>
                    <p className="text-gray-700" data-id="element-63">Buenos Aires, Argentina</p>
                  </div>
                </div>
              </div>
              <div className="mt-8" data-id="element-64"></div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}